export default __webpack_public_path__ + "static/media/arrowRight.15399ae0.svg";